import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useReactToPrint } from 'react-to-print';

import Cheque from '../../../components/Cheque';

function Rightbar({ showRightBar, setShowRightBar, selectedItem, toggleModalDelete }) {
	const { t } = useTranslation()

	const printRef = useRef();

	const handlePrint = useReactToPrint({
		content: () => printRef.current,
	});

	return (
		<>
			{showRightBar &&
				<>
					<div className="right-sidebar-background" onClick={() => setShowRightBar(!showRightBar)}></div>
					<div className="right-sidebar">
						<div className="position-relative">
							<div className="rightbar-close-icon" onClick={() => setShowRightBar(!showRightBar)}>
								<i className="uil uil-times"></i>
							</div>
						</div>
						<Cheque data={selectedItem} show={true} />

						<div className="d-flex justify-content-between mb-3 px-2">
							<span>{t('action')}</span>
							<div className="d-flex gap-2">
								{!!selectedItem.deleteable &&
									<div className="table-action-button table-action-danger-button ms-2"
										onClick={() => toggleModalDelete(true)}>
										<i className="uil-times"></i>
									</div>
								}
								<div className="table-action-button table-action-primary-button"
									onClick={handlePrint}>
									<i className="uil uil-print"></i>
								</div>
							</div>
						</div>
					</div>

					<Cheque data={selectedItem} printChequeRef={printRef} />
				</>
			}
		</>
	)
}

export default Rightbar
